import AgencyEstimate from 'client/common/components/agency-estimate/AgencyEstimate';

export default AgencyEstimate;
